<template>
  <div>
    <!-- modal modalIsBringIn -->
    <fe-alert ref="modalIsBringIn" :datas="dataAlertBringIn" v-on:modal-close="onXCloseModal()">
      <template v-slot:default>
        <div class="form-group text-left cursor-default">
          <span v-html="dataAlertBringIn.text"></span>
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="onModalConfirmBringIn"
          class="btn-dialog col-6 border-top border-right color-red"
        >{{ dataAlertBringIn.btn.yes }}</button>
        <button
          type="button"
          @click="onModalConfirmNoBringIn"
          class="btn-dialog col-6 border-top border-left"
        >{{ dataAlertBringIn.btn.no }}</button>
      </template>
    </fe-alert>
  </div>
</template>
<script>
import FeAlert from "@/components/fe/common/FeAlert";
import { mapGetters } from "vuex";
export default {
  name: "ModalA045",
  components: {
    FeAlert
  },
  created() {},
  computed: {
    ...mapGetters(["shopMode", "userData"])
  },
  mounted() {
    this.$refs.modalIsBringIn.show();
  },
  data() {
    return {
      dataAlertBringIn: {
        isShow: false,
        isShowClose: true,
        text: this.$t("front_end.a035.alert.text.continue_order_mode_store"),
        btn: {
          yes: this.$t("front_end.a035.alert.button.bring_in"),
          no: this.$t("front_end.a035.alert.button.no_bring_in")
        },
        modalContentClass: "width-md mx-auto"
      }
    };
  },
  methods: {
    onXCloseModal() {
      this.$router.push({ name: "a035" });
    },
    onCloseModal() {
      this.$router.push({ name: "a035" });
    },

    onModalConfirmBringIn() {
      this.onConfirmBringIn(true);
    },
    onModalConfirmNoBringIn() {
      this.onConfirmBringIn(false);
    },

    onConfirmBringIn(cf) {
      this.$refs.modalIsBringIn.hide();
      this.$store.commit("userData/SET_SELECTED", {
        is_bring_in: cf
      });

      // this.onCloseModal();

      if (this.userData.selected?.is_print_address) {
        this.$router.push({ name: "a050" });
      } else {
        this.$router.push({ name: "a060" });
      }
    }
  }
};
</script>

<style scoped>
.btn-custom {
  max-height: 37px;
}
.w100 {
  width: 100%;
}
.pd-0 {
  padding: 0px !important;
}

.icon-select {
  color: red;
  position: absolute;
  right: 0;
  font-size: 25px;
  margin: 10px;
}
@media screen and (min-width: 1024px) {
  .icon-select {
    font-size: 25px;
    margin: 10px;
  }
}
@media screen and (max-width: 768px) {
  .icon-select {
    font-size: 15px;
    margin: 10px;
  }
  .btn-custom {
  }
}
@media screen and (max-width: 480px) {
  .icon-select {
    font-size: 15px;
    margin: 5px;
  }
  .btn-custom {
    padding: 5px;
    max-height: 33px;
  }
}

.color-red {
  color: #dd0017;
}
.close-dialog {
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>
